export const FETCH_ACCOUNTS_BEGIN = "ACCOUNTS_LOAD_BEGIN";
export const FETCH_ACCOUNTS_SUCCESS = "ACCOUNTS_LOAD_SUCCESS";
export const FETCH_ACCOUNTS_ERROR = "ACCOUNTS_LOAD_ERROR";

export const FETCH_CLAIM_BEGIN = "FETCH_CLAIM_BEGIN";
export const FETCH_CLAIM_SUCCESS = "FETCH_CLAIM_SUCCESS";
export const FETCH_CLAIM_ERROR = "FETCH_CLAIM_ERROR";

export const DELETE_CLAIM_BEGIN = "DELETE_CLAIM_BEGIN";
export const DELETE_CLAIM_SUCCESS = "DELETE_CLAIM_SUCCESS";
export const DELETE_CLAIM_ERROR = "DELETE_CLAIM_ERROR";

export const FETCH_PENDING_CLAIMS_BEGIN = "FETCH_PENDING_CLAIMS_BEGIN";
export const FETCH_PENDING_CLAIMS_SUCCESS = "FETCH_PENDING_CLAIMS_SUCCESS";
export const FETCH_PENDING_CLAIMS_ERROR = "FETCH_PENDING_CLAIMS_ERROR";

export const FETCH_PENDING_CLAIMS_REPORT_BEGIN = "FETCH_PENDING_CLAIMS_REPORT_BEGIN";
export const FETCH_PENDING_CLAIMS_REPORT_SUCCESS = "FETCH_PENDING_CLAIMS_REPORT_SUCCESS";
export const FETCH_PENDING_CLAIMS_REPORT_ERROR = "FETCH_PENDING_CLAIMS_REPORT_ERROR";

export const FETCH_CLAIM_ITEMS_BEGIN = "FETCH_CLAIM_ITEMS_BEGIN";
export const FETCH_CLAIM_ITEMS_SUCCESS = "FETCH_CLAIM_ITEMS_SUCCESS";
export const FETCH_CLAIM_ITEMS_ERROR = "FETCH_CLAIM_ITEMS_ERROR";

export const FETCH_CLAIM_ITEM_FIELDS_BEGIN = "FETCH_CLAIM_ITEM_FIELDS_BEGIN";
export const FETCH_CLAIM_ITEM_FIELDS_SUCCESS = "FETCH_CLAIM_ITEM_FIELDS_SUCCESS";
export const FETCH_CLAIM_ITEM_FIELDS_ERROR = "FETCH_CLAIM_ITEM_FIELDS_ERROR";

export const FETCH_CLAIM_ITEM_ACCOUNTS_BEGIN = "FETCH_CLAIM_ITEM_ACCOUNTS_BEGIN";
export const FETCH_CLAIM_ITEM_ACCOUNTS_SUCCESS = "FETCH_CLAIM_ITEM_ACCOUNTS_SUCCESS";
export const FETCH_CLAIM_ITEM_ACCOUNTS_ERROR = "FETCH_CLAIM_ITEM_ACCOUNTS_ERROR";

export const FETCH_BENEFIT_PLANS_BEGIN = "FETCH_BENEFIT_PLANS_BEGIN";
export const FETCH_BENEFIT_PLANS_SUCCESS = "FETCH_BENEFIT_PLANS_SUCCESS";
export const FETCH_BENEFIT_PLANS_ERROR = "FETCH_BENEFIT_PLANS_ERROR";

export const FETCH_CLAIMS_BEGIN = "FETCH_CLAIMS_BEGIN";
export const FETCH_CLAIMS_SUCCESS = "FETCH_CLAIMS_SUCCESS";
export const FETCH_CLAIMS_ERROR = "FETCH_CLAIMS_ERROR";

export const SUBMIT_CLAIM_UPLOAD_BEGIN = "SUBMIT_CLAIM_UPLOAD_BEGIN";
export const SUBMIT_CLAIM_UPLOAD_SUCCESS = "SUBMIT_CLAIM_UPLOAD_SUCCESS";
export const SUBMIT_CLAIM_BEGIN = "SUBMIT_CLAIM_UPLOAD_BEGIN";
export const SUBMIT_CLAIM_SUCCESS = "SUBMIT_CLAIM_SUCCESS";
export const SUBMIT_CLAIM_ERROR = "SUBMIT_CLAIM_ERROR";

export const FETCH_CLAIM_LIMIT_MESSAGES_REQUEST = "FETCH_CLAIM_LIMIT_MESSAGES_REQUEST";
export const FETCH_CLAIM_LIMIT_MESSAGES_SUCCESS = "FETCH_CLAIM_LIMIT_MESSAGES_SUCCESS";
export const FETCH_CLAIM_LIMIT_MESSAGES_FAILURE = "FETCH_CLAIM_LIMIT_MESSAGES_FAILURE";

export const FETCH_EMPLOYEES_BY_DELEGATION_BEGIN = "FETCH_EMPLOYEES_BY_DELEGATION_BEGIN";
export const FETCH_EMPLOYEES_BY_DELEGATION_SUCCESS = "FETCH_EMPLOYEES_BY_DELEGATION_SUCCESS";
export const FETCH_EMPLOYEES_BY_DELEGATION_ERROR = "FETCH_EMPLOYEES_BY_DELEGATION_ERROR";

export const CHANGE_CURRENCY_CODE = "CHANGE_CURRENCY_CODE";

export const CHANGE_CURRENCY_RATE = "CHANGE_CURRENCY_RATE";

export const DISPLAY_CLAIM_ITEM_FIELDS_REQUEST = "DISPLAY_CLAIM_ITEM_FIELDS_REQUEST";
export const DISPLAY_CLAIM_ITEM_FIELDS_SUCCESS = "DISPLAY_CLAIM_ITEM_FIELDS_SUCCESS";
export const DISPLAY_CLAIM_ITEM_FIELDS_FAILURE = "DISPLAY_CLAIM_ITEM_FIELDS_FAILURE";

export const FETCH_BALANCE_DETAIL_BEGIN = "FETCH_BALANCE_DETAIL_BEGIN";
export const FETCH_BALANCE_DETAIL_SUCCESS = "FETCH_BALANCE_DETAIL_SUCCESS";
export const FETCH_BALANCE_DETAIL_ERROR = "FETCH_BALANCE_DETAIL_ERROR";


// WEBPACK FOOTER //
// ./actions/claimActionTypes.js